/**
 * Which of our JEPX balancing groups an order is placed under. JEPX takes it
 * as the order's `location`, and generator and retailer are separate groups, so
 * the trader has to pick one per algo. Sent as `configuration.balancing_group`
 * when an algo is created; an update echoes the algo's existing group back and
 * can never change it.
 *
 * Kept a dependency-free leaf like `algoSpec.ts`, since `types.tsx` reads
 * {@link DEFAULT_BALANCING_GROUP} at module scope.
 */
export enum BalancingGroup {
  GENERATOR = "generator",
  RETAILER = "retailer",
}

export const balancingGroupLabel: Record<BalancingGroup, string> = {
  [BalancingGroup.GENERATOR]: "Generator",
  [BalancingGroup.RETAILER]: "Retailer",
};

/**
 * What every new form starts on. Deliberately not the trader's last pick: a
 * group carried over from the previous algo is too easy to submit unnoticed
 * under the wrong one.
 */
export const DEFAULT_BALANCING_GROUP = BalancingGroup.RETAILER;
